import register from '@kpsys/angularjs-register';
import providersModule from 'shared/providers/providers.module';
import userFinancePanelModule from 'src/features/user/kp-user-finance-panel/user-finance-panel.module';
import ReaderLoanDataService from './reader-loan.data-service';
import UserDataService from './user.data-service';
import userRoutes from './user.routes';
import UserService from './user.service';
import TransactionDataService from 'src/features/user/kp-user-finance-panel/transaction.data-service';
import UserPreferencesDataService from './user-preferences/user-preferences.data-service';
import {UserPreferencesService} from './user-preferences/user-preferences.service';
import {KpUserAccountPageService} from './kp-user-account-page/kp-user-account-page.service';
import {KpUserListPageService} from './kp-user-list-page/kp-user-list-page.service';
import {WalletBarcodeCardDataService} from 'src/features/user/kp-user-barcode-card/wallet-barcode-card.data-service';
import {WalletBarcodeCardService} from 'src/features/user/kp-user-barcode-card/wallet-barcode-card.service';

export default register('portaro.features.user', [userFinancePanelModule, providersModule])
    .config(userRoutes)
    .service(ReaderLoanDataService.serviceName, ReaderLoanDataService)
    .service(UserDataService.serviceName, UserDataService)
    .service(UserService.serviceName, UserService)
    .service(TransactionDataService.serviceName, TransactionDataService)
    .service(UserPreferencesDataService.serviceName, UserPreferencesDataService)
    .service(UserPreferencesService.serviceName, UserPreferencesService)
    .service(KpUserAccountPageService.serviceName, KpUserAccountPageService)
    .service(KpUserListPageService.serviceName, KpUserListPageService)
    .service(WalletBarcodeCardDataService.serviceName, WalletBarcodeCardDataService)
    .service(WalletBarcodeCardService.serviceName, WalletBarcodeCardService)
    .name();